import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=7de0b012&scoped=true"
import script from "./Snack.vue?vue&type=script&lang=ts"
export * from "./Snack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de0b012",
  null
  
)

export default component.exports